import { auth } from "../../typings/auth";

// scopes rights (responsible user)
interface Restriction {
    restriction?: auth.Scopes;
    restricted?: boolean;
}
export interface NavLink extends Restriction {
    title: string;
    path?: string;
}

export class NavLinkController {
    public static $inject: string[] = [
        "authService",
        "toaster"
    ];

    public userRights: auth.Scopes[];

    constructor(
        protected authService,
        protected toaster
    ) {
        this.userRights = authService.getUserRights();
    }

    public checkRestriction(event, { restriction, restricted }: Restriction) {
        if (restricted) {
            event.preventDefault();

            if (restriction === auth.Scopes.PAYOUTS) {
                return this.toaster.toastContactSupport(auth.Scopes.PAYOUTS);
            }

            if (restriction === auth.Scopes.BA_ACCESS) {
               return this.toaster.toastContactEmailBusiness();
            }

            this.toaster.toastContactSupport();
        }
    }

    public getRestriction(restriction: auth.Scopes): Restriction {
        return {
            restriction,
            restricted: !this.userRights[restriction]
        };
    }
}
